document.addEventListener("DOMContentLoaded", function () {
    var imageModal = new tingle.modal({
        closeMethods: [], // Disable default close methods
    });

    function openImageModal(imageUrl) {
        var modalContent = `
            <button class="custom-close-btn" id="customClose"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20" fill="currentColor">
  <path d="M9.5 1.25C14.32 1.25 18.25 5.17 18.25 10S14.33 18.75 9.5 18.75 0.75 14.83 0.75 10 4.67 1.25 9.5 1.25ZM9.5 0.5C4.25 0.5 0 4.75 0 10s4.25 9.5 9.5 9.5 9.5-4.25 9.5-9.5S14.75 0.5 9.5 0.5Z"/>
  <path d="M13.26 5.84L5.34 13.77l.39.39 7.93-7.93-.4-.39Z"/>
  <path d="M5.73 5.84l-.39.39 7.93 7.93.39-.39L5.73 5.84Z"/>
</svg></button>
            <img src="${imageUrl}" style="max-width:100%; height:auto; display:block; margin:0 auto;">
        `;

        imageModal.setContent(modalContent);
        imageModal.open();

        // Add event listener to the custom close button
        document.getElementById("customClose").addEventListener("click", function () {
            imageModal.close();
        });
    }

    document.getElementById("openModalButton").addEventListener("click", function () {
        // openImageModal("https://cdn.shopify.com/s/files/1/0596/3769/4519/files/size-guide.jpg"); // Replace with your image URL
        let imageUrl = document.getElementById("size-guide-img-url").src; // Get image src by ID
        openImageModal(imageUrl);
    });

});



/** Collection Page To Filter */
// document.querySelectorAll('.size-button').forEach(button => {
//     button.addEventListener('click', function (event) {
//         event.preventDefault();
//         const url = new URL(window.location.href);
//         url.searchParams.set(this.name, this.value);
//         window.location.href = url.toString();
//     });
// });
document.addEventListener("DOMContentLoaded", function () {
    const sizeButtons = document.querySelectorAll(".size-button");
    const resetButton = document.getElementById("reset-filter") ?? '';

    function checkActiveFilters() {
        let hasActive = false;
        sizeButtons.forEach(button => {
            if (button.classList.contains("active")) {
                hasActive = true;
            }
        });

        // Show or hide the reset button based on active filters
        if (resetButton) {
            if (hasActive) {
                resetButton.style.display = "inline-block";
            } else {
                resetButton.style.display = "none";
            }
        }
    }

    sizeButtons.forEach(button => {
        button.addEventListener("click", function () {
            let selectedSize = this.getAttribute("data-value");
            let paramName = this.getAttribute("data-param");

            // Update the URL without reloading
            let url = new URL(window.location.href);
            url.searchParams.set(paramName, selectedSize);
            history.pushState({}, "", url);

            // Fetch new products using AJAX
            updateProductGrid(url);

            // Highlight the selected size
            sizeButtons.forEach(btn => btn.classList.remove("active"));
            button.classList.add("active");

            checkActiveFilters(); // Check if reset button should be displayed
        });
    });

    // Reset button functionality
    if (resetButton) {
        resetButton.addEventListener("click", function () {
            let url = new URL(window.location.href);
            sizeButtons.forEach(button => {
                let paramName = button.getAttribute("data-param");
                url.searchParams.delete(paramName); // Remove size filter
            });

            history.pushState({}, "", url);
            updateProductGrid(url);

            // Remove active class from all size buttons
            sizeButtons.forEach(btn => btn.classList.remove("active"));

            checkActiveFilters(); // Hide reset button when filters are cleared
        });
    }

    // Function to update the product grid dynamically
    function updateProductGrid(url) {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");
                let newProducts = doc.querySelector(".collection-product-grid");

                if (newProducts) {
                    document.querySelector(".collection-product-grid").innerHTML = newProducts.innerHTML;
                }
            })
            .catch(error => console.error("Error fetching filtered products:", error));
    }

    // Initial check to see if any filters are active on page load
    checkActiveFilters();
});


/** Collection Page To Filter End */



/**
 * Reset the filter on button click of top filter
 */
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.getElementsByClassName("reset-filter");
    if (buttons.length > 0) {
        buttons[0].addEventListener("click", function () {
            const button2 = document.getElementsByClassName("facets__clear-all")[0];
            if (button2) {
                button2.click();
            }
        });
    }
});



/** Add the birth date on subscription form */
function copyToHidden() {
    var visibleInput = document.getElementById('visibleInput').value;
    document.getElementById('hiddenInput').value = 'newsletter, ' + visibleInput;
}

/** Smooth Scrolling */
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });